import DarkMode from './dark-mode';

export default DarkMode;